package floris.graphics.landing.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import floris.graphics.core.constants.Res
import com.materialdesignsystem.constants.Attributes
import com.materialdesignsystem.toColorScheme
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

@Composable
fun TabItem(modifier: Modifier = Modifier, active: Boolean, text: String, onClick: () -> Unit) {
    SpanText(
        modifier = modifier
            .then(TabStyle.toModifier())
            .thenIf(active) {
                Modifier.borderBottom(2.px, LineStyle.Solid, ColorMode.current.toColorScheme.onBackground)
            }
            .fontWeight(FontWeight.Bold)
            .fontSize(24.px)
            .lineHeight(34.px)
            .cursor(Cursor.Pointer)
            .onClick { onClick() },
        text = text
    )
}

@Composable
fun TabList(
    items: List<String>,
    activeTab: String? = null,
    onItemClicked: (item: String?) -> Unit
) {
    TabItem(
        active = activeTab == null,
        text = Res.String.ShowAll,
        onClick = {
            onItemClicked(null)
        }
    )

    items.forEach { item ->
        TabItem(
            active = activeTab == item,
            text = item,
            onClick = {
                onItemClicked(item)
            })
    }
}

val TabStyle = CssStyle {
    base {
        Modifier.transition(Transition.of(Attributes.Border, 0.ms))
    }

    hover {
        Modifier.borderBottom(2.px, LineStyle.Solid, colorMode.toColorScheme.onBackground)
    }
}
